import { createReducer, on } from '@ngrx/store';
import { defaultRecipientListFilter } from '../types/recipient-list-filter';
import {
  fetchRecipientList,
  loadedRecipientList,
  failedRecipientList,
  updateRecipientListFilter,
  resetRecipientList,
  deleteRecipient,
} from './recipient-list.actions';
import {
  initialRecipientListState,
  RecipientListState,
  initialDataSource,
} from './recipient-list.state';
import { RecipientListInterface } from '../types/recipient-list';

export const recipientListReducer = createReducer(
  initialRecipientListState,
  on(fetchRecipientList, (state): RecipientListState => ({ ...state })),
  on(loadedRecipientList, (state, action): RecipientListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedRecipientList, (state): RecipientListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(updateRecipientListFilter, (state, { filter }): RecipientListState => {
    return {
      ...state,
      filter: { ...state.filter, ...(filter ?? defaultRecipientListFilter) },
      dataSource: { ...state.dataSource },
    };
  }),
  on(deleteRecipient, (state, action): RecipientListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: {
        ...state.dataSource,
        rawData: state.dataSource.rawData?.filter(
          (recipient: RecipientListInterface) =>
            recipient.bene_id !== action.bene_id
        ),
      },
    };
  }),
  on(resetRecipientList, (state): RecipientListState => {
    return {
      ...state,
      filter: { ...defaultRecipientListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
